import {  IconButton, Collapse, CircularProgress,} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import CloseIcon from '@material-ui/icons/Close';


const StatusDisplay = ({isRunning,successMessage,setSuccessMessage,error,setError})=>{
    return (
        <div>
            {isRunning ? (<CircularProgress />) : ('') }
            <Collapse in={successMessage !== ''}>
                <Alert action={
                        <IconButton aria-label="close" color="inherit" size="small" onClick={() => { setSuccessMessage('');}} >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }>
                    {successMessage}
                </Alert>
            </Collapse>
            <Collapse in={error !== ''}>
                <Alert severity="error" action={
                        <IconButton aria-label="close" color="inherit" size="small" onClick={() => { setError(''); }} >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }>
                    {error}
                </Alert>
            </Collapse>
        </div>
     );   
};
export default StatusDisplay
